const viewList = ['accounts', 'data_connectors', 'shared_accounts', 'preferences']
const viewIndex = location.pathname === '/settings' ? viewList.indexOf((location.search.match(/[?&]view=(\w+)(&|$)/) || [null, 'accounts'])[1]) : 0
const initialState = {
  viewList: viewList,
  viewIndex: viewIndex < 0 ? 0 : viewIndex,
  sellApiTokenStatus: {},
  sellApiTokenFetched: false,
  preferences: {
    defaultTimezone: null,
    shopifySettings: {},
    bigcommerceSettings: {},
    amazonSettings: {},
    walmartSettings: {},
    contacts: {},
    socialAccounts: {},
    currencySettings: {},
    shippingSettings: {},
    inventorySettings: {},
  },
  preferencesStatus: 'idle',
  preferencesModified: false,
  dataConnectorsStatus: 'loading',
  dataConnectorsError: null,
  shipstationConfigs: null,
  shippingeasyConfigs: null,
}

export default function reducer(state = initialState, action) {
  switch(action.type) {
    case "SET_VIEW_SETTINGS": {
      return {
        ...state,
        viewIndex: action.payload,
      }
    }
    case "SET_SELL_API_TOKEN_STATUS_SETTINGS": {
      return {
        ...state,
        sellApiTokenStatus: action.payload,
      }
    }
    case "FETCH_SELL_API_TOKEN_FULFILLED_SETTINGS": {
      return {
        ...state,
        sellApiTokenFetched: action.payload,
      }
    }
    case "SET_PREFERENCES_SETTINGS": {
      const payload = action.payload || {}
      const prev = state.preferences
      const next = { ...prev }
      for (const key of Object.keys(payload)) {
        const value = payload[key]
        if (value == null) continue
        if (key === 'shippingSettings' && typeof value === 'object') {
          next.shippingSettings = { ...(prev.shippingSettings || {}), ...value }
        } else {
          next[key] = value
        }
      }
      return {
        ...state,
        preferences: next,
      }
    }
    case "SET_PREFERENCES_STATUS_SETTINGS": {
      return {
        ...state,
        preferencesStatus: action.payload,
      }
    }
    case "SET_PREFERENCES_MODIFIED_SETTINGS": {
      return {
        ...state,
        preferencesModified: action.payload,
      }
    }
    case 'SET_DATA_CONNECTORS_STATUS_SETTINGS': {
      return {
        ...state,
        dataConnectorsStatus: action.payload,
      }
    }
    case 'SET_DATA_CONNECTORS_ERROR_SETTINGS': {
      return {
        ...state,
        dataConnectorsError: action.payload,
      }
    }
    case 'SET_SHIPSTATION_CONFIGS_SETTINGS': {
      return {
        ...state,
        shipstationConfigs: action.payload,
      }
    }
    case 'SET_SHIPPINGEASY_CONFIGS_SETTINGS': {
      return {
        ...state,
        shippingeasyConfigs: action.payload,
      }
    }
  }
  return state
}